import { MarkingProgress } from '../../types';

/**
 * Why an exam can't be unpublished or deleted right now — it has marks — or
 * '' when it can. The server enforces the same rule; this lets the buttons
 * say so before anyone tries.
 */
export const markedExamBlock = (progress: Pick<MarkingProgress, 'recorded'> | undefined, action: 'unpublish' | 'delete') =>
  progress?.recorded
    ? `${progress.recorded} mark${progress.recorded === 1 ? ' is' : 's are'} recorded. Clear them before you ${action === 'delete' ? 'delete' : 'unpublish'} this exam.`
    : '';

/** "12 of 40 papers marked" */
export const progressText = (p: MarkingProgress) => `${p.recorded} of ${p.papers} paper${p.papers === 1 ? '' : 's'} marked`;
